import { render, staticRenderFns } from "./LocacoesPage.vue?vue&type=template&id=a5c531ca&"
import script from "./LocacoesPage.vue?vue&type=script&lang=js&"
export * from "./LocacoesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports